import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ImplodeExplodeAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const s = progress < 0.25 ? (1 - progress / 0.25) : (progress - 0.25) * 4;
  drawBlastShape(ctx, e, e.maxRadius * s);
  ctx.lineWidth = 20 * (1 - progress); ctx.stroke();
};

registerBlastAnimation('IMPLODE_EXPLODE', ImplodeExplodeAnimation);
